export default [
    { path: '/dashboard', component: require('./components/Dashboard.vue').default },
    { path: '/profile', component: require('./components/Profile.vue').default },
    { 
        path: '/developer', 
        component: require('./components/Developer.vue').default,
        meta: { requiresAdmin: true }
    },
    { 
        path: '/pelanggan', 
        component: require('./components/calonpelanggan/Pelanggan.vue').default ,
        meta:{permission: 'is_pelanggan'}
    },

    // Inventory
    {
        path: '/inventory/modem/print-qr',
        component: require('./components/inventory/PrintQrModem.vue').default,
        meta: { permission: 'is_master' }
    },
    {
        path: '/inventory/modem',
        component: require('./components/inventory/Modem.vue').default,
        meta: { permission: 'is_master' }
    },

    // master
    {
        path: '/kode_akun',
        component: require('./components/master/KodeAkun.vue').default,
        meta: { permission: 'is_master' }

    },
    {
        path: '/kode_bantu',
        component: require('./components/master/KodeBantu.vue').default,
        meta: { permission: 'is_master' }
    },
    // end master

    // jurnal
    { 
        path: '/jurnal', 
        component: require('./components/jurnal/InputJurnal.vue').default, 
        meta:{permission: 'is_keuangan'}
    },
    // end jurnal
    { 
        path: '/users_online', 
        component: require('./components/pelanggans/UsersOnline.vue').default,
        meta:{permission:'is_pelanggan'}
    },
    { 
        path: '/pelanggan_aktif', 
        component: require('./components/pelanggans/Internet.vue').default ,
        meta:{permission: 'is_pelanggan'}
    },
    { 
        path: '/pelanggan_suspend', 
        component: require('./components/pelanggans/Suspended.vue').default ,
        meta:{permission: 'is_pelanggan'}
    },
    { 
        path: '/dismantle', 
        component: require('./components/pelanggans/Dismantle.vue').default ,
        meta:{permission: 'is_pelanggan'}
    },
    { 
        path: '/pelanggan_nonaktif', 
        component: require('./components/pelanggans/Nonaktif.vue').default,
        meta:{permission: 'is_pelanggan'}
    },

    { 
        path: '/invoice_prorate', 
        component: require('./components/invoice/Prorate_permintaan.vue').default,
        meta:{permission:'is_invoice'}
    },
    { 
        path: '/rekap_closing', 
        component: require('./components/invoice/Rekap_closing.vue').default,
        meta:{permission:'is_invoice'}
    },
    { 
        path: '/rekap_closing_online', 
        component: require('./components/invoice/Rekap_closing_online.vue').default,
        meta:{permission:'is_invoice'}
    },
   
    { 
        path: '/invoice_generated', 
        component: require('./components/invoice/Generated.vue').default,
        meta:{permission:'is_invoice'}
    },
    { 
        path: '/invoice_unpaid', 
        component: require('./components/invoice/Unpaid.vue').default,
        meta:{permission:'is_invoice'}
    },
    { 
        path: '/invoice_paid', 
        component: require('./components/invoice/Paid.vue').default,
        meta:{permission:'is_invoice'}
    },
    { 
        path: '/invoice_refund', 
        component: require('./components/invoice/Refund.vue').default,
        meta:{permission:'is_invoice'}
    },
    { 
        path: '/invoice_suspended', 
        component: require('./components/invoice/Suspended.vue').default,
        meta:{permission:'is_invoice'}
    },
    { 
        path: '/invoice_paid_overdue', 
        component: require('./components/invoice/PaidOverdue.vue').default,
        meta:{permission:'is_invoice'}
    },

    { 
        path: '/uang_keluar_permintaan_cek_selesai', 
        component: require('./components/keuangan/Keluar_permintaan_cek.vue').default,
        meta:{permission: 'is_keuangan'}
    },
    { 
        path: '/uang_keluar_permintaan_cek', 
        component: require('./components/keuangan/Keluar_permintaan_cek.vue').default,
        meta:{permission: 'is_keuangan'}
    },
    { 
        path: '/pencatatan_utang', 
        component: require('./components/keuangan/pencatatan-utang/Pencatatan_Utang.vue').default,
        meta:{permission: 'is_keuangan'}
    },
    { 
        path: '/pencatatan_piutang', 
        component: require('./components/keuangan/pencatatan-piutang/Pencatatan_PIUtang.vue').default,
        meta:{permission: 'is_keuangan'}
    },
    { 
        path: '/uang_keluar_permintaan', 
        component: require('./components/keuangan/Keluar_permintaan.vue').default,
        meta:{permission: 'is_keuangan'}
    },
    { 
        path: '/uang_keluar', 
        component: require('./components/keuangan/Keluar.vue').default,
        meta:{permission: 'is_keuangan'}
    },
    { 
        path: '/uang_keluar_estimasi', 
        component: require('./components/keuangan/Estimasi.vue').default,
        meta:{permission: 'is_keuangan'}
    },
    { 
        path: '/uang_keluar_overview', 
        component: require('./components/keuangan/Keluar_overview.vue').default,
        meta:{permission: 'is_keuangan'}
    },
    { 
        path: '/overview-kas', 
        component: require('./components/keuangan/ArusKas.vue').default,
        meta:{permission: 'is_keuangan'}
    },
    { 
        path: '/uang_masuk', 
        component: require('./components/keuangan/Masuk.vue').default,
        meta:{permission: 'is_keuangan'}
    },
    { 
        path: '/cashback_unpaid', 
        component: require('./components/keuangan/Cashback_unpaid.vue').default,
        meta:{permission: 'is_keuangan'}
    },
    { 
        path: '/ppn_unpaid', 
        component: require('./components/keuangan/Ppn_unpaid.vue').default,
        meta:{permission: 'is_keuangan'}
    },
    { 
        path: '/pph_unpaid', 
        component: require('./components/keuangan/Pph_unpaid.vue').default,
        meta:{permission: 'is_keuangan'}
    },
    { 
        path: '/zakat_unpaid', 
        component: require('./components/keuangan/Zakat_unpaid.vue').default,
        meta:{permission: 'is_keuangan'}
    },
    { 
        path: '/cashback_paid', 
        component: require('./components/keuangan/Cashback_paid.vue').default,
        meta:{permission: 'is_keuangan'}
    },
    { 
        path: '/ppn_paid', 
        component: require('./components/keuangan/Ppn_paid.vue').default,
        meta:{permission: 'is_keuangan'}
    },
    { 
        path: '/pph_paid', 
        component: require('./components/keuangan/Pph_paid.vue').default,
        meta:{permission: 'is_keuangan'}
    },
    { 
        path: '/zakat_paid', 
        component: require('./components/keuangan/Zakat_paid.vue').default,
        meta:{permission: 'is_keuangan'}
    },

    { 
        path: '/laporan_riwayat', 
        component: require('./components/laporan/Riwayat.vue').default,
        meta:{permission: 'is_laporan'}
    },
    //{ path: '/laporan_riwayat?id=:id_plg', name: 'laporan_riwayat', component: require('./components/laporan/Riwayat.vue').default },
    { 
        path: '/laporan_keuangan', 
        component: require('./components/laporan/Keuangan.vue').default,
        meta:{permission: 'is_laporan'} 
    },
    { 
        path: '/laporan_laba_rugi', 
        component: require('./components/laporan/LabaRugi.vue').default,
        meta:{permission: 'is_laporan'} 
    },
    { 
        path: '/logs_payment', 
        component: require('./components/logs/Payment.vue').default,
        meta:{permission: 'is_laporan'} 
    },
    { 
        path: '/logs_kick', 
        component: require('./components/logs/Kick.vue').default,
        meta:{requiresAdmin: true} 
    },
    { 
        path: '/logs_activity', 
        component: require('./components/logs/Activity.vue').default,
        meta:{requiresSuperAdmin: true} 
    },
    { 
        path: '/rekap_invoice', 
        component: require('./components/laporan/RekapInvoice.vue').default,
         meta: { requiresAdmin: true }
    },
    { 
        path: '/rekap_invoice_tahunan', 
        component: require('./components/laporan/RekapInvoiceTahunan.vue').default,
        meta: { permission: 'is_laporan' }
    },

    { 
        path: '/approval', 
        component: require('./components/approval/Waiting.vue').default,
        meta:{permission:'is_approval'} 
    },
    { 
        path: '/approval_budget', 
        component: require('./components/approval/Waiting_budget.vue').default,
        meta:{permission:'is_approval'} 
    },
    { 
        path: '/approval_invoice', 
        component: require('./components/approval/Waiting_invoice.vue').default,
        meta:{permission:'is_approval'} 
    },
    { 
        path: '/approved', 
        component: require('./components/approval/Approved.vue').default,
        meta:{permission:'is_approval'} 
    },
    { 
        path: '/disapproved', 
        component: require('./components/approval/Disapproved.vue').default,
        meta:{permission:'is_approval'} 
    },

    {
        path: '/users',
        component: require('./components/Users.vue').default,
        meta: { requiresAdmin: true }
    },
    { 
        path: '/router', 
        name: 'master_router', 
        component: require('./components/master/Router.vue').default,
         meta: { requiresAdmin: true }
    },
    { 
        path: '/paket', 
        name: 'master_paket', 
        component: require('./components/master/Paket.vue').default,
         meta: { requiresAdmin: true }
    },
    { 
        path: '/roles', 
        name: 'master_roles', 
        component: require('./components/master/Roles.vue').default,
         meta: { requiresAdmin: true }
    },
    { 
        path: '/kcb', 
        name: 'master_kantor', 
        component: require('./components/master/Kantor.vue').default,
         meta: { requiresAdmin: true }
    },
    { 
        path: '/products', 
        name: 'products', 
        component: require('./components/product/Products.vue').default,
         meta: { requiresAdmin: true }
    },
    { 
        path: '/sales', 
        component: require('./components/master/Sales.vue').default,
         meta: { requiresAdmin: true }
    },
    { 
        path: '/product/tag', 
        component: require('./components/product/Tag.vue').default,
         meta: { requiresAdmin: true }
    },
    { 
        path: '/product/category', 
        component: require('./components/product/Category.vue').default,
         meta: { requiresAdmin: true }
    },
    {
        path: '/not-allowed',
        name: 'not-allowed',
        component: require('./components/NotAllowed.vue').default,
    },
    { path: '*', component: require('./components/NotFound.vue').default },
];
